import * as React from "react";
import ISpouse from "src/services/interfaces/ISpouse";

export const SpouseInfo = (props: { spouse: ISpouse }) => (
  <div className="region-container spouse-info">
    <span className="subtitle">Dados do Cônjuge</span>
    <div>
      <div className="row">
        <span className="left description">Nome:</span>
        <span className="right description">{props.spouse?.fullName}</span>
      </div>
      <div className="row">
        <span className="left description">Documento:</span>
        <span className="right description">{props.spouse?.cpf}</span>
      </div>
      <div className="row">
        <span className="left description">RG:</span>
        <span className="right description">
          {props.spouse?.rg}/{props.spouse?.rgState}
        </span>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/SpouseInfo/SpouseInfo.tsx